var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTravel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.491,
    height: 45,
    viewBox: "0 0 52.491 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TRAVEL",
    transform: "translate(-82.747 -50.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M405.994,321.687a.7.7,0,1,1-.7-.7.695.695,0,0,1,.7.7",
    transform: "translate(-290.249 -243.587)",
    fill: "#0076bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M303.84,276.86H272.716a1.425,1.425,0,0,0-1.426,1.426v19.957a1.425,1.425,0,0,0,1.426,1.426H303.84a1.425,1.425,0,0,0,1.426-1.426V278.286A1.426,1.426,0,0,0,303.84,276.86Zm-14.86,13.158-6.5-6.5.742-3.486,3.486-.742,6.5,6.5Z",
    transform: "translate(-170.027 -203.789)",
    fill: "#0076bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M364.227,216.2v-1.434a1.425,1.425,0,0,1,1.426-1.426h8.157a1.426,1.426,0,0,1,1.426,1.426V216.2h2.613v-1.434a4.044,4.044,0,0,0-4.039-4.039h-8.157a4.045,4.045,0,0,0-4.039,4.039V216.2Z",
    transform: "translate(-251.48 -144.148)",
    fill: "#0076bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M100.792,67.911l2.121,4.139h5.378l-1.957-9.678,7.908-7.91a2.1,2.1,0,0,0-2.969-2.967L103.365,59.4,84.4,55.566l-1.649,1.649,15.078,7.727L90.1,72.663,86.03,71.84,84.38,73.489l5.2,2.667,2.665,5.2,1.65-1.65-.825-4.077Z",
    transform: "translate(0 0)",
    fill: "#0076bf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravel);
export default __webpack_public_path__ + "static/media/ic-travel.3293e8d0.svg";
export { ForwardRef as ReactComponent };